const { NODE_ENV } = process.env;
const FF = require(`./featureFlip/${
  NODE_ENV !== "production" ? "development" : "production"
}.json`);

export { FF };
